import { accent, dc, dcSoft } from "../hooks/tokens.js";
import { ARTICLES } from "../data.js";

const filters = ["Tous", "Fondamentaux", "Routage", "Commutation", "Sécurité", "Automatisation"];

// Index A→Z de toutes les fiches, filtrable par domaine.
export function buildIndexView(ctx) {
  const { s, patch, go } = ctx;
  const rows = ARTICLES.filter((a) => s.indexFilter === "Tous" || a.domain === s.indexFilter)
    .slice().sort((a, b) => a.title.localeCompare(b.title, "fr"));

  return {
    indexCount: ARTICLES.length,
    indexFilters: filters.map((f) => ({
      label: f, border: f === s.indexFilter ? accent : "oklch(0.92 0.008 85)",
      color: f === s.indexFilter ? accent : "oklch(0.45 0.015 60)",
      onClick: () => patch({ indexFilter: f }),
    })),
    indexRows: rows.map((a) => ({
      letter: a.title[0].toUpperCase(), title: a.title, summary: a.summary, domain: a.domain,
      domainColor: dc(a.domain), domainBg: dcSoft(a.domain),
      onClick: () => go(a.id),
    })),
  };
}
